define('modules/form/form_view',[
  'backbone',
  'jquery',
  '_',

  './form_model',
  'text!./form_template.html',
  './form_item_collection',


  'modules/form/CreateField'
], function(Backbone, $, _, FormModel, form_template, FormItemCollection, CreateField) {
  'use strict';
  var View = Backbone.View.extend({

    initialize: function(opts) {

      _.extend(this, opts);

      this.collection = new FormItemCollection(this.fields);
      this.dataModel = new Backbone.Model();

      this.render();
    },
    tagName: 'form',
    className: 'form',
    model: new FormModel(),
    subViews: [],
    template: _.template(form_template),

    render: function() {
      var Field = CreateField.extend();

      this.$el.html(this.template(this.model.toJSON()));


      var currentRoute = Backbone.history.getFragment();
      var currentRouteHasZoneId = currentRoute.includes('?zone_id=');

      if(this.collection.length) {
        var form_items = [];
        this.collection.each(function (field) {
          // if (this.readonly) {
          //   field.set('readonly', true);
          // }

          // Using the route to see if we reached the template picker page from the zone selector.
          if (field.get('type') === 'tags' && 
            field.get('readonly') === true &&
            currentRouteHasZoneId) {
            field.set('readonly', true);
          } else {
            field.set('readonly', false);
          }

          if (this.filter_id) {
            field.set('filter_id', this.filter_id);
          }
          var field_view = new Field({model: field, dataModel: this.dataModel});
          this.subViews.push(field_view);
          form_items.push(field_view.$el);
        }, this);

        this.$('.form-body').html(form_items);
      }
      return this;
    },

    remove: function() {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

